// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3WvlW","info":"PatientInfo_info__2FBNC"};